module.exports = __webpack_public_path__ + "36a7cc57e6ba7f7ab76a9d739c9127e9.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/CO.svg
// module id = u5FQ
// module chunks = 0